"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMilestoneRewardByDays = getMilestoneRewardByDays;
exports.getMilestoneRewardValue = getMilestoneRewardValue;
/**
 * 根据天数获取里程碑奖励配置
 */
function getMilestoneRewardByDays(rewards, days) {
    return rewards.find((r) => r.days === days);
}
/**
 * 根据天数获取奖励价值（无奖励配置时返回 undefined）
 */
function getMilestoneRewardValue(rewards, days) {
    return getMilestoneRewardByDays(rewards, days)?.rewardValue;
}
